import { render, staticRenderFns } from "./transfer-order.vue?vue&type=template&id=1232dff7&"
import script from "./transfer-order.vue?vue&type=script&lang=ts&"
export * from "./transfer-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports